<template>
  <a-card title="编辑会员等级" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol"
    >
      <a-form-model-item prop="levelName" label="会员等级名称">
        <a-input v-model="ruleForm.levelName" :maxLength="6" placeholder="请输入" style="max-width: 500px;"/>
      </a-form-model-item>
      <a-form-model-item prop="level" label="等级级别">
        <div class="title">一级（最高级别）</div>
        <a-steps :initial='1' :current="ruleForm.level" style="max-width: 500px;">
          <span slot="progressDot" slot-scope="{ prefixCls }" :class="`${prefixCls}-icon-dot`"/>
          <a-step v-for="(item,index) in dataList" :key="index" :title="item.value"/>
        </a-steps>
      </a-form-model-item>
      <a-form-model-item label="升级门槛" required>
        <div class="row-li">
          <span>有效期内累计获得 </span>
          <a-form-model-item prop="upgradePoint" style="width: 120px;display: inline-block;margin-bottom: 0">
            <a-input-number v-model="ruleForm.upgradePoint" :step='1' :min="0" :max="100000000" placeholder="请输入"
                            style="width: 100%;"/>
          </a-form-model-item>
          <span> 积分达标</span>
        </div>
        <div class="tips">当前周期结束前一日累计积分将作为下个周期的会员等级参考值（升级、保级或降级）。</div>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
        <a-button @click="backEvent" style="margin-left: 15px;">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'EditMemberAscend',
  mixins: [ruleFormLayout],
  data() {
    return {
      submitLoading: false,
      id: 0,
      ruleForm: {
        id: 0,
        level: 0,
        levelName: '',
        upgradePoint: 0
      },
      rules: {
        levelName: [{ required: true, message: '请输入会员等级名称', trigger: 'blur' }],
        upgradePoint: [
          { required: true, message: '请输入积分值', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
        ]
      },
      dataList: []
    }
  },
  created() {
    this.getMemberLevelEnum()
  },
  mounted() {
    this.id = this.getPageParams().id
    this.getMemberDetail()
  },
  methods: {
    getMemberDetail() {
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/detail/' + this.id).then(res => {
        this.getLogUtils().logWithTag('详情', res)
        this.ruleForm = { ...res }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    getMemberLevelEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/getMemberLevelEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.dataList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getIntegralApiService().post('admin/memberLevel/update', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('编辑会员等级成功')
        setTimeout(() => {
          this.backEvent()
        }, 800)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }
}
</script>

<style scoped lang="less">
.tips {
  color: rgba(51, 51, 51, 0.45);
  height: 20px;
  line-height: 20px;
}
</style>